// DestinationFactStrip — compact row of practical facts (language, currency,
// plug type, timezone, visa). Each is optional; the strip collapses gracefully.
import React from 'react';
import { B } from '../constants';

export default function DestinationFactStrip({ content }) {
  if (!content) return null;
  const facts = [
    { label: 'Language',  value: content.language, icon: '🗣️' },
    { label: 'Currency',  value: content.currency, icon: '💱' },
    { label: 'Plug type', value: content.plugType, icon: '🔌' },
    { label: 'Timezone',  value: content.timezone, icon: '🕐' },
    { label: 'Visa',      value: content.visa,     icon: '🛂' },
  ].filter((f) => f.value);

  if (facts.length === 0) return null;

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fit, minmax(140px, 1fr))`,
        gap: 12,
        background: '#fff',
        border: `1px solid ${B.sand}`,
        borderRadius: 12,
        padding: 16,
        margin: '16px 0',
      }}
    >
      {facts.map((f) => (
        <div key={f.label} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 20 }}>{f.icon}</span>
          <div>
            <div style={{ fontSize: 11, color: B.muted, textTransform: 'uppercase', letterSpacing: 0.5 }}>
              {f.label}
            </div>
            <div style={{ fontSize: 14, color: B.night, fontWeight: 600 }}>{f.value}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
